"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Option = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var React = __importStar(require("react"));
var Flex_1 = require("../Flex");
var Typography_1 = require("../Typography");
var View_1 = require("../View");
var theme_1 = require("../theme");
var OptionIcon = function (_a) {
    var icon = _a.icon, disabled = _a.disabled;
    return (React.createElement(React.Fragment, null, icon && (React.createElement(View_1.View, { width: "auto", minWidth: "auto", marginRight: "space8", color: disabled ? 'n200' : 'n900' }, icon))));
};
var OptionBadge = function (_a) {
    var badge = _a.badge, disabled = _a.disabled;
    return (React.createElement(React.Fragment, null, badge && (React.createElement(View_1.View, { display: "flex", marginLeft: "space8", opacity: disabled ? 'semiOpaque' : 'opaque' }, badge))));
};
var OptionText = function (_a) {
    var text = _a.text, disabled = _a.disabled, _b = _a.selected, selected = _b === void 0 ? false : _b;
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography_1.Paragraph, { color: disabled ? 'n200' : 'n900', fontWeight: selected ? 'bold' : 'regular' }, text)));
};
/**
 * Note: This is supposed to have a line-height of 20px but because of the 14px
 * font, it's calculating to 17.5px
 */
var OptionDescription = function (_a) {
    var description = _a.description, disabled = _a.disabled;
    return (React.createElement(React.Fragment, null, description && (React.createElement(Typography_1.Paragraph, { fontSize: "fontsize14", color: disabled ? 'n200' : 'n400', marginTop: "space4" }, description))));
};
var OptionListItem = styled_1.default.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: ", " ", ";\n  background: ", ";\n  min-width: 220px;\n  width: 280px;\n  max-width: 340px;\n  font-size: ", ";\n  line-height: ", ";\n  list-style: none;\n\n  &:hover {\n    background-color: ", ";\n    cursor: ", ";\n  }\n\n  &:focus {\n    outline: 1px solid ", ";\n  }\n\n  &[aria-selected='true'] {\n    background: ", ";\n  }\n"], ["\n  padding: ", " ", ";\n  background: ", ";\n  min-width: 220px;\n  width: 280px;\n  max-width: 340px;\n  font-size: ", ";\n  line-height: ", ";\n  list-style: none;\n\n  &:hover {\n    background-color: ", ";\n    cursor: ", ";\n  }\n\n  &:focus {\n    outline: 1px solid ", ";\n  }\n\n  &[aria-selected='true'] {\n    background: ", ";\n  }\n"])), theme_1.spacing.space8, theme_1.spacing.space16, theme_1.colors.surface200, theme_1.fontSizes.fontsize16, theme_1.lineHeights.lineheight24, function (props) { return (!props.disabled ? theme_1.colors.n70 : ''); }, function (props) { return (props.disabled ? 'not-allowed' : 'pointer'); }, theme_1.colors.blue500, theme_1.colors.blue100);
var Option = function (_a) {
    var icon = _a.icon, badge = _a.badge, text = _a.text, description = _a.description, disabled = _a.disabled, rest = __rest(_a, ["icon", "badge", "text", "description", "disabled"]);
    var _b = React.useState(false), selected = _b[0], setSelected = _b[1];
    React.useEffect(function () {
        if (rest['aria-selected'] === 'true') {
            setSelected(true);
        }
    }, [rest]);
    return (React.createElement(OptionListItem, __assign({ role: "option", disabled: disabled }, rest),
        React.createElement(Flex_1.Flex, null,
            React.createElement(OptionIcon, { icon: icon, disabled: disabled }),
            React.createElement(View_1.View, null,
                React.createElement(Flex_1.Flex, { alignItems: "center" },
                    React.createElement(OptionText, { text: text, selected: selected, disabled: disabled }),
                    React.createElement(OptionBadge, { badge: badge, disabled: disabled })),
                React.createElement(OptionDescription, { description: description, disabled: disabled })))));
};
exports.Option = Option;
var templateObject_1;
//# sourceMappingURL=Option.js.map